import 'css-chunksrc/client/pages/projectPage/timeSheetPage/styles.scss';export default {
  "timeSheetPage": "_timeSheetPage_1vgbg_1",
  "filters": "_filters_1vgbg_9",
  "filtersRight": "_filtersRight_1vgbg_20",
  "main": "_main_1vgbg_27",
  "content": "_content_1vgbg_34",
  "header": "_header_1vgbg_40",
  "row": "_row_1vgbg_56",
  "footer": "_footer_1vgbg_70"
};